//--------------- E-MAIL TRANSACIONAL (RESEND) ---------------//
import api from "../../../shared/services/api";

const emailConfigService = {
  obter:           () => api.get("/integracoes/email-config"),
  salvar:          (payload) => api.put("/integracoes/email-config", payload),
  dominios:        () => api.get("/integracoes/email-config/dominios"),
  garantirWebhook: () => api.post("/integracoes/email-config/webhook/garantir"),
  rastreio:        (dominioId, payload) => api.put(`/integracoes/email-config/dominios/${dominioId}/rastreio`, payload),
  verificarDominio: (dominioId) => api.post(`/integracoes/email-config/dominios/${dominioId}/verificar`),
  testar:          (para) => api.post("/integracoes/email-config/testar", { para }),
};

export default emailConfigService;
